module.exports = __webpack_public_path__ + "static/img/THFZ.cd37b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/THFZ.png
// module id = uyqq
// module chunks = 34